/* eslint-disable @typescript-eslint/explicit-function-return-type */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-empty-function */
import { h, render } from "preact";
import styled from "styled-px2rem";
import { Mask, Toast } from "antd-mobile";
import CopyText from "react-copy-text";
import { useState, useEffect } from "preact/hooks";
import ColseBtn from "@images/colse.png";
const MaskWrap = ({ title, message, type, callback }: any) => {
    const [text, setText] = useState("");
    const [visible, setVisible] = useState(false);
    const ContainerDiv: any=document.getElementById("container");
    useEffect(() => {
        setVisible(true);
    }, [])
    return (<Mask className="z_9999" visible={visible} disableBodyScroll={true}>
        <Container>
            {type == 0 && <CopyWrap>
                <CopayTitle>{title}</CopayTitle>
                <TextWrap>{message}</TextWrap>
                <CopyText text={text} />
                <CopyButton onClick={() => {
                    setText(message);
                    Toast.show({ content: "复制成功" })
                    setTimeout(() => {
                        render(null, ContainerDiv);
                    }, 100);
                }}>复制</CopyButton>
                {type == 0 && <ColseBtnWrap src={ColseBtn} onClick={() => {
                    render(null,ContainerDiv);
                }} />}
            </CopyWrap>}
            {type == 1 && <ConfirmWrap>
                <ConfirmText>{title}</ConfirmText>
                <ConfirmButtonWrap>
                    <CancleButton onClick={() => {
                        render(null,ContainerDiv);
                    }}>取消</CancleButton>
                    <ConfirmButton onClick={() => {
                        callback();
                        render(null,ContainerDiv);
                    }}>前往</ConfirmButton>
                </ConfirmButtonWrap>
            </ConfirmWrap>}
        </Container>
    </Mask>);
}
const MaskPopup = {
    showCopay: (title: any, message: any) => {
        const ContainerDiv: any=document.getElementById("container");
        render(<MaskWrap title={title} message={message} type={0} />, ContainerDiv);
    },
    close: () => {
        const ContainerDiv: any=document.getElementById("container");
        render(null,ContainerDiv);
    },
    showConfirm: (title: any, callback: any) => {
        const ContainerDiv: any=document.getElementById("container");
        render(<MaskWrap callback={callback} title={title} type={1} />, ContainerDiv);
    },
};
export default MaskPopup;
const Container = styled.div`
    width:100vw;
    height:100vh;
    display:flex;
    flex-direction:column;
    align-items:center;
    justify-content:center;
`;
const ConfirmWrap = styled.div`
    width: 420px;
    height: 205px;
    background: #FFFFFF;
    border-radius: 8px;
    padding-top:50px;
`;
const ConfirmText = styled.div`
    font-weight: 400;
    color: #333333;
    line-height: 18Px;
    font-size:13Px;
    text-align:center;
`;
const ConfirmButtonWrap = styled.div`
    margin-top:46px;
    display: flex;
    flex-direction:row;
    align-items:center;
    justify-content:center;
`;
const CancleButton = styled.div`
    width: 100px;
    height: 48px;
    border-radius: 1px;
    border: 1px solid #999999;
    font-weight: 400;
    color: #666666;
    font-size:12Px;
    margin-right:36px;
    display:flex;
    flex-direction:row;
    justify-content:center;
    align-items:center;
`;
const ConfirmButton = styled.div`
    width: 100px;
    height: 48px;
    background: #FF6400;
    border-radius: 1px;
    font-weight: 400;
    color: #FFFFFF;
    font-size:12Px;
    display: flex;
    flex-direction:row;
    justify-content:center;
    align-items:center;
`;
//拷贝
const CopyWrap = styled.div`
    position:relative;
    width: 488px;
    background: #F5F5F5;
    border-radius: 5px;
    padding:46px 30px 35px 30px;
    background:#fff;
`;
const CopayTitle = styled.div`
    font-weight: 600;
    color: #333333;
    line-height: 21Px;
    font-size:15Px;
    text-align:center;
`;
const TextWrap = styled.div`
    margin-top:36px;
    background: #F5F5F5;
    border-radius: 5px;
    padding:16px;
    font-weight: 400;
    color: #333333;
    font-size:13Px;
    line-height:16Px;
    min-height:100px;
`;
const CopyButton = styled.div`
    margin-top:26px;
    width: 100%;
    height: 56px;
    background: #FF6400;
    border-radius: 5px;
    display: flex;
    flex-direction:row;
    justify-content:center;
    align-items:center;
    font-weight: 400;
    color: #FFFFFF;
    font-size:12Px;
`;
const ColseBtnWrap = styled.img`
    position:absolute;
    right:-25px;
    top:-25px;
    width:50px;
    height:50px;
`;